import styled from "styled-components";
import LogoGray from "../../assets/images/SSD_white_logo.png";
import { Link } from "react-router-dom";

const FooterContainer = styled.footer`
  max-width: 1600px;
  width: 100%;
  padding: 60px 16px;
  background-color: #333333;
  color: #fff;
`;

const FooterLogo = styled.img`
  width: 150px;
`;

const FooterInner = styled.div`
  max-width: 1600px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: space-between;
  gap: 20px;
  position: relative;
  font-size: 13px;
`;

const FooterContent = styled.p`
  display: flex;
  flex-direction: column;
  gap: 13px;
  font-weight: 300;
  line-height: 20px;
`;

const Divider = styled.span`
`;

const FooterContentText = styled.span`
  font-weight: 300;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  word-break: keep-all;
`;

const FooterBottomContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 10px;
  padding-top: 30px;

  @media (max-width: 560px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }
`

const FooterCopyright = styled.span`
  color: #fff;
  font-weight: 300;
`;

const PersonalInformation = styled.div`
  display: flex;
  gap: 10px;
  width: 100%;
  max-width: 200px;
`

const TitleContent = styled.span`
  font-weight: 500;
`

const AddressContent = styled.span`
`

const TelContent = styled.span`
`

const MobileFooter = () => {
  const handleTermsClick = () => {
    alert("준비 중인 서비스입니다.")
  }

  return (
    <FooterContainer>
      <FooterInner>
        <FooterLogo src={LogoGray} alt="회계법인 새시대" />
        <FooterContent>
          <FooterContentText>
            <TitleContent>본점 :</TitleContent>
            <AddressContent>
              서울특별시 영등포구 양산로 107, 인곡빌딩 4층, 7층, 9층
            </AddressContent>
            <Divider>|</Divider>
            <TelContent>
              02-2635-8939
            </TelContent>
          </FooterContentText>
          <FooterContentText>
            <TitleContent>구로분실 :</TitleContent>
            <AddressContent>
              서울특별시 구로구 경인로 53길 15, 407호 (구로동, 업무A동)
            </AddressContent>
            <Divider>|</Divider>
            <TelContent>
              02-6679-5500
            </TelContent>
          </FooterContentText>
          <FooterContentText>
            <TitleContent>강남분실 :</TitleContent>
            <AddressContent>
              서울특별시 강남구 테헤란로 38길 29, 6층 (역삼동, 이원빌딩)
            </AddressContent>
            <Divider></Divider>
            <TelContent>
            </TelContent>
          </FooterContentText>
          <FooterContentText>
            <TitleContent>광주지점(분사무소) :</TitleContent>
            <AddressContent>
              광주광역시 서구 상무대로 759,4층(치평동, 지산빌딩)
            </AddressContent>
            <Divider>|</Divider>
            <TelContent>
              062-373-5573
            </TelContent>
          </FooterContentText>
        </FooterContent>
        <FooterBottomContainer>
          <PersonalInformation>
            <Link onClick={handleTermsClick}>
              이용약관
            </Link>
            <span>
              |
            </span>
            <Link onClick={handleTermsClick}>
              개인정보처리방침
            </Link>
          </PersonalInformation>
          <FooterCopyright>
            Copyright © by 회계법인 새시대 All rights reserved.
          </FooterCopyright>
        </FooterBottomContainer>
      </FooterInner>
    </FooterContainer>
  );
};

export default MobileFooter;
